
export default [

        {
            path:'/shoeMaterial',
            name:'shoeMaterial',
            component:() => import('@/views/shoeMaterial/shoeMaterial'),
            meta: {
    
                keepAlive: true, //此组件需要被缓存
    
            }
    
        },
        
]


// WEBPACK FOOTER //
// ./src/router/shoeMaterial.js